export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-shape/src/identity.js
// module id = ../../../../d3-shape/src/identity.js
// module chunks = 4